import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { API_BASE_URL, INSET_CUSTOMER } from "../../Config";
import Axios from "axios";
import { Spin } from "antd";
import PropTypes from "prop-types";

const AddCustomerModal = ({ isOpen, onClose, onCustomerAdded }) => {
  const [userDataSession, setUserDataSession] = useState(null);
  const [addFormData, setAddFormData] = useState(null);
  const [addAddressType, setAddAddressType] = useState("Office");
  const [addSubmitBtnLoading, setAddSubmitBtnLoading] = useState(false);

  // Session
  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
    }
  }, []);

  // Initialize form when session is ready
  useEffect(() => {
    if (userDataSession) {
      setAddFormData({
        orgid: Number(userDataSession.OrgId),
        userid: Number(userDataSession.UserId),
        Customer: {
          Name: "",
          Email: "",
          Mobile: "",
          Notes: "",
          DOB: null,
          Anniversary: null,
          CardNumber: "",
          Amount: 0,
          EmpType: 0,
          IsPostPaidAllowed: false,
          CustGroupId: 0,
          IsActive: true,
          GSTIN: "",
        },
        Address: {
          Name: "",
          Mobile: "",
          AddressType: "Office",
          HouseNo: "",
          ApartmentName: "",
          AreaName: "",
          LandMark: "",
          City: "",
          State: "",
          Country: "India",
          PinCode: "",
          Longitude: 0,
          Latitude: 0,
          IsActive: true,
        },
      });
    }
  }, [userDataSession]);

  const handleAddAddressSelectChange = (event) => {
    const value = event.target.value;
    setAddAddressType(value);
    setAddFormData((prev) => ({
      ...prev,
      Address: { ...prev.Address, AddressType: value },
    }));
  };

  const handleAddInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    let finalValue = value;

    if (type === "checkbox") {
      finalValue = checked;
    } else if (
      ["number", "PinCode"].includes(type) ||
      name.includes("Amount") ||
      name.includes("EmpType") ||
      name.includes("CustGroupId") ||
      name.includes("Latitude") ||
      name.includes("Longitude")
    ) {
      finalValue = value === "" ? 0 : Number(value);
    }

    const [objectName, key] = name.split(".");
    if (objectName && key) {
      setAddFormData((prevState) => ({
        ...prevState,
        [objectName]: {
          ...prevState[objectName],
          [key]: finalValue,
        },
      }));
    } else {
      setAddFormData((prevState) => ({
        ...prevState,
        [name]: finalValue,
      }));
    }
  };

  const handleAddSubmit = (e) => {
    e.preventDefault();
    if (!addFormData) return;
    setAddSubmitBtnLoading(true);

    const payload = { ...addFormData };
    payload.orgid = Number(userDataSession.OrgId);
    payload.userid = Number(userDataSession.UserId);

    Axios.post(`${API_BASE_URL}${INSET_CUSTOMER}`, payload)
      .then((response) => {
        setAddSubmitBtnLoading(false);
        if (response.data[0]?.Success === 1) {
          Swal.fire({
            title: "Success!",
            text: "Customer added successfully.",
            icon: "success",
          }).then(() => {
            // Reset form
            setAddFormData({
              ...addFormData,
              Customer: {
                ...addFormData.Customer,
                Name: "",
                Email: "",
                Mobile: "",
                Notes: "",
                DOB: null,
                Anniversary: null,
                CardNumber: "",
                GSTIN: "",
              },
              Address: {
                ...addFormData.Address,
                HouseNo: "",
                ApartmentName: "",
                AreaName: "",
                LandMark: "",
                City: "",
                State: "",
                PinCode: "",
                Mobile: "",
                Latitude: 0,
                Longitude: 0,
              },
            });

            // Notify parent to refresh customer list
            if (onCustomerAdded) onCustomerAdded();

            // Close modal
            onClose();
          });
        } else {
          Swal.fire({
            title: "Error",
            text: response.data[0]?.Message || "Failed to add customer.",
            icon: "error",
          });
        }
      })
      .catch((error) => {
        console.log(error);
        setAddSubmitBtnLoading(false);
        Swal.fire({
          title: "Error",
          text: "An error occurred while adding the customer.",
          icon: "error",
        });
      });
  };

  if (!userDataSession) return null;

  return (
    <>
      {addSubmitBtnLoading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 2050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          }}
        >
          {/* <SpinLoader /> */}
          <Spin size="large" tip="Processing..." />
        </div>
      )}

      {isOpen && (
        <div
          className="modal fade show d-block"
          // id="addcustomer" // Changed ID
          // data-bs-backdrop="static"
          style={{ backgroundColor: "rgba(131, 125, 125, 0.5)109, 0.5)" }}
         onClick={onClose}
          data-bs-keyboard="false"
          tabIndex="-1"
        >
          <div
            className="modal-dialog modal-dialog-centered custom-modal-two mt-5"
            style={{ maxWidth: "70%" }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              <div className="page-wrapper-new p-0">
                <div className="content">
                  <div className="modal-header border-0 custom-modal-header">
                    <div className="page-title">
                      <h4>Add Customer</h4>
                    </div>
                    <button
                      type="button"
                      className="close d-flex ms-auto"
                      //   data-bs-dismiss="modal"
                      onClick={onClose}
                      aria-label="Close"
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>
                  <div
                    className="modal-body custom-modal-body"
                    style={{ height: "520px" }}
                  >
                    {/* Tabs, form, fields – exactly the same as before */}
                    <ul
                      className="nav nav-tabs tab-style-2 nav-justified mb-3 d-sm-flex d-block"
                      id="myTab1"
                      role="tablist"
                    >
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link active"
                          id="order-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#order-tab-pane-add"
                          type="button"
                          role="tab"
                        >
                          <i className="fa-regular fa-address-book me-1 align-middle"></i>
                          Personal Info
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link"
                          id="shipped-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#shipped-tab-pane-add"
                          type="button"
                          role="tab"
                        >
                          <i className="fa-solid fa-house-user me-1 align-middle"></i>
                          Address
                        </button>
                      </li>
                    </ul>

                    <form onSubmit={handleAddSubmit}>
                      <div className="tab-content" id="myTabContent">
                        {/* Personal Info Tab – same as before */}
                        <div
                          className="tab-pane fade show active"
                          id="order-tab-pane-add"
                          role="tabpanel"
                        >
                          <div className="row">
                            <div className="col-lg-4">
                              <div className="input-blocks">
                                <label>Name</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="Customer.Name"
                                  value={addFormData?.Customer.Name || ""}
                                  onChange={handleAddInputChange}
                                  placeholder="Enter customer name"
                                  required
                                />
                              </div>
                            </div>
                            <div className="col-lg-4">
                              <div className="input-blocks">
                                <label>Email</label>
                                <input
                                  type="email"
                                  className="form-control"
                                  name="Customer.Email"
                                  value={addFormData?.Customer.Email || ""}
                                  onChange={handleAddInputChange}
                                  placeholder="Enter email"
                                  // required
                                />
                              </div>
                            </div>
                            <div className="col-lg-4">
                              <div className="input-blocks">
                                <label>Phone</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="Customer.Mobile"
                                  value={addFormData?.Customer.Mobile || ""}
                                  onChange={handleAddInputChange}
                                  placeholder="Enter phone no"
                                  required
                                />
                              </div>
                            </div>
                            <div className="col-lg-4">
                              <div className="input-blocks">
                                <label>Date Of Birth</label>
                                <input
                                  type="date"
                                  className="form-control"
                                  name="Customer.DOB"
                                  value={addFormData?.Customer.DOB || ""}
                                  onChange={handleAddInputChange}
                                />
                              </div>
                            </div>
                            <div className="col-lg-4">
                              <div className="input-blocks">
                                <label>Anniversary</label>
                                <input
                                  type="date"
                                  className="form-control"
                                  name="Customer.Anniversary"
                                  value={
                                    addFormData?.Customer.Anniversary || ""
                                  }
                                  onChange={handleAddInputChange}
                                />
                              </div>
                            </div>
                            <div className="col-lg-4">
                              <div className="input-blocks">
                                <label>Card Number</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="Customer.CardNumber"
                                  value={addFormData?.Customer.CardNumber || ""}
                                  onChange={handleAddInputChange}
                                  placeholder="Enter card number"
                                />
                              </div>
                            </div>
                            <div className="col-lg-12">
                              <div className="input-blocks">
                                <label>Notes</label>
                                <textarea
                                  type="text"
                                  className="form-control"
                                  name="Customer.Notes"
                                  value={addFormData?.Customer.Notes || ""}
                                  onChange={handleAddInputChange}
                                  placeholder="Enter notes..."
                                ></textarea>
                              </div>
                            </div>
                            <div className="col-lg-4 d-none">
                              <div className="input-blocks ">
                                <label>GSTIN</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="Customer.GSTIN"
                                  value={addFormData?.Customer.GSTIN || ""}
                                  onChange={handleAddInputChange}
                                  placeholder="Enter GSTIN"
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 d-none">
                              <div className="input-blocks">
                                <label>Is Active</label>
                                <div className="form-check">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    name="Customer.IsActive"
                                    id="addCustomerIsActive"
                                    checked={
                                      addFormData?.Customer.IsActive || false
                                    }
                                    onChange={handleAddInputChange}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="addCustomerIsActive"
                                  >
                                    Active
                                  </label>
                                </div>
                              </div>
                            </div>
                            {/* Hidden fields remain hidden as per your code */}
                            <div className="col-lg-4 d-none">
                              <div className="input-blocks">
                                <label>Employee Type</label>
                                <input
                                  type="number"
                                  className="form-control"
                                  name="Customer.EmpType"
                                  value={addFormData?.Customer.EmpType || 0}
                                  onChange={handleAddInputChange}
                                  placeholder="Enter EmpType (e.g., 0)"
                                  min="0"
                                  onWheel={(e) => e.target.blur()}
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 d-none">
                              <div className="input-blocks">
                                <label>Is Post Paid Allowed</label>
                                <div className="form-check">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    name="Customer.IsPostPaidAllowed"
                                    id="addIsPostPaidAllowed"
                                    checked={
                                      addFormData?.Customer.IsPostPaidAllowed ||
                                      false
                                    }
                                    onChange={handleAddInputChange}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="addIsPostPaidAllowed"
                                  >
                                    Post Paid Allowed
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 d-none">
                              <div className="input-blocks">
                                <label>Customer Group ID</label>
                                <input
                                  type="number"
                                  className="form-control"
                                  name="Customer.CustGroupId"
                                  value={addFormData?.Customer.CustGroupId || 0}
                                  onChange={handleAddInputChange}
                                  placeholder="Enter CustGroupId"
                                  min="0"
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Address Tab   */}
                        <div
                          className="tab-pane fade"
                          id="shipped-tab-pane-add"
                          role="tabpanel"
                        >
                          <div className="row">
                           
                            <div className="col-lg-4 col-sm-10 col-10">
                              <div className="input-blocks">
                                <label>Country</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value="India"
                                  style={{ cursor: "not-allowed" }}
                                  readOnly
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-sm-10 col-10">
                              <div className="input-blocks">
                                <label>House No</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="Address.HouseNo"
                                  value={addFormData?.Address.HouseNo || ""}
                                  onChange={handleAddInputChange}
                                  placeholder="Enter HouseNo"
                                />
                              </div>
                            </div>
                            <div className="col-lg-4">
                              <div className="input-blocks">
                                <label>Area</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="Address.AreaName"
                                  value={addFormData?.Address.AreaName || ""}
                                  onChange={handleAddInputChange}
                                  placeholder="Enter area name"
                                />
                              </div>
                            </div>
                            <div className="col-lg-4">
                              <div className="input-blocks">
                                <label>Appartment</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="Address.ApartmentName"
                                  value={
                                    addFormData?.Address.ApartmentName || ""
                                  }
                                  onChange={handleAddInputChange}
                                  placeholder="Enter appartment name"
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-sm-10 col-10">
                              <div className="input-blocks">
                                <label>City</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="Address.City"
                                  value={addFormData?.Address.City || ""}
                                  onChange={handleAddInputChange}
                                  placeholder="Enter city"
                                />
                              </div>
                            </div>

                            <div className="col-lg-4 col-sm-10 col-10">
                              <div className="input-blocks">
                                <label>State</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="Address.State"
                                  value={addFormData?.Address.State || ""}
                                  onChange={handleAddInputChange}
                                  placeholder="Enter state"
                                />
                              </div>
                            </div>
                            <div className="col-lg-4">
                              <div className="input-blocks">
                                <label>ZipCode</label>
                                <input
                                  type="number"
                                  className="form-control"
                                  name="Address.PinCode"
                                  value={addFormData?.Address.PinCode || ""}
                                  onChange={handleAddInputChange}
                                  placeholder="Enter pincode"
                                />
                              </div>
                            </div>

                            <div className="col-lg-4">
                              <div className="input-blocks">
                                <label>Landmark</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="Address.LandMark"
                                  value={addFormData?.Address.LandMark || ""}
                                  onChange={handleAddInputChange}
                                  placeholder="Enter landmark"
                                />
                              </div>
                            </div>
                            <div className="col-lg-4">
                              <div className="input-blocks">
                                <label>Address Type</label>
                                <select
                                  className="form-select"
                                  value={addAddressType}
                                  onChange={handleAddAddressSelectChange}
                                >
                                  <option value="Office">Office</option>
                                  <option value="Residential">
                                    Residential
                                  </option>
                                </select>
                              </div>
                            </div>
                            <div className="col-lg-4">
                              <div className="input-blocks">
                                <label>Address Mobile</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="Address.Mobile"
                                  value={addFormData?.Address.Mobile || ""}
                                  onChange={handleAddInputChange}
                                  placeholder="Enter address mobile"
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 d-none">
                              <div className="input-blocks">
                                <label>Address Is Active</label>
                                <div className="form-check">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    name="Address.IsActive"
                                    id="addAddressIsActive"
                                    checked={
                                      addFormData?.Address.IsActive || false
                                    }
                                    onChange={handleAddInputChange}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="addAddressIsActive"
                                  >
                                    Active
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4">
                              <div className="input-blocks">
                                <label>Latitude</label>
                                <input
                                  type="number"
                                  step="any"
                                  className="form-control"
                                  name="Address.Latitude"
                                  value={addFormData?.Address.Latitude || ""}
                                  onChange={handleAddInputChange}
                                  placeholder="Enter latitude"
                                />
                              </div>
                            </div>
                            <div className="col-lg-4">
                              <div className="input-blocks">
                                <label>Longitude</label>
                                <input
                                  type="number"
                                  step="any"
                                  className="form-control"
                                  name="Address.Longitude"
                                  value={addFormData?.Address.Longitude || ""}
                                  onChange={handleAddInputChange}
                                  placeholder="Enter longitude"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="d-flex justify-content-end mt-4">
                        <button
                          type="button"
                          className="btn btn-cancel me-2"
                          onClick={onClose}
                          //   data-bs-dismiss="modal"
                          disabled={addSubmitBtnLoading}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn btn-submit"
                          disabled={addSubmitBtnLoading}
                        >
                          {addSubmitBtnLoading ? "Submitting..." : "Submit"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AddCustomerModal;

AddCustomerModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onCustomerAdded: PropTypes.func,
};

AddCustomerModal.defaultProps = {
  isOpen: false,
  onClose: () => {},
  onCustomerAdded: () => {},
};
